import { AllPublications } from "../views/Logged/Publications/AllPublications";
import { update } from "./requests/dynamicReq";

export const ROUTES = {
  Login: "/",
  ManageProfile: "/perfil",
  Users: {
    all: "/usuarios",
    update: "/usuarios/:id",
    create: "/usuarios/crear",
  },
  Groups: {
    all: "/grupos",
    update: "/grupos/:id",
    create: "/grupos/crear",
  },
  Projects: {
    all: "/proyectos",
    update: "/proyectos/:id",
    create: "/proyectos/crear",
  },
  Subjects: {
    all: "/asignaturas",
    update: "/asignaturas/:id",
    create: "/asignaturas/crear",
  },
  Publications: {
    all: "/publicaciones",
    update: "/publicaciones/:id",
    create: "/publicaciones/crear",
  },
  News: {
    all: "/noticias",
    update: "/noticias/:id",
    create: "/noticias/crear",
  },
  Degree: {
    all: "/formacion",
    update: "/formacion/:id",
    create: "/formacion/crear",
  },
  TeachingResources: {
    all: "/teachingResources",
    update: "/teachingResources/:id",
    create: "/teachingResources/crear",
  },
  Archive: {
    all: "/archivo",
    update: "",
    create: "",
  },
  Commissions: {
    all: "/commissions",
    update: "/commissions/:id",
    create: "/commissions/crear",
  },
  Lines: {
    all: "/transversalActions",
    update: "/transversalActions/:id",
    create: "/transversalActions/crear",
  },
  Patents: {
    all: "/patents",
    update: "/patents/:id",
    create: "/patents/crear",
  },
  Offers: {
    all: "/offers",
    update: "/offers/:id",
    create: "/offers/crear",
  },
  Announcements: {
    all: "/announcements",
    update: "/announcements/:id",
    create: "/announcements/crear",
  },
  Sliders: {
    all: "/sliders",
    update: "/sliders/:id",
    create: "sliders/crear",
  },
  Resource: {
    all: "/resource",
    update: "/resource/:id",
    create: "resource/crear",
  },
  Ambitos: {
    all: "/ambitos",
    update: "/ambitos/:id",
    create: "/ambitos/crear",
  },
  Tesis: {
    all: "/tesis",
    update: "/tesis/:id",
    create: "/tesis/crear",
  },
  Seminars: {
    all: "/seminarios",
    update: "/seminarios/:id",
    create: "/seminarios/crear",
  },
  EntidadesParticipantes: {
    all: "/entidades-participantes",
    update: "/entidades-participantes/:id",
    create: "/entidades-participantes/crear",
  },
  EntidadesFinanciadoras: {
    all: "/entidades-financiadoras",
    update: "/entidades-financiadoras/:id",
    create: "/entidades-financiadoras/crear",
  },
  Convocatorias: {
    all: "/convocatorias",
    update: "/convocatorias/:id",
    create: "/convocatorias/crear",
  },
  Propuestas: {
    all: "/propuestas",
    update: "/propuestas/:id",
    create: "/propuestas/crear",
  },
  SerieLibros: {
    all: "/serie-libros",
    update: "/serie-libros/:id",
    create: "/serie-libros/crear",
  },
  Revistas: {
    all: "/revistas",
    update: "/revistas/:id",
    create: "/revistas/crear",
  },
  Libros: {
    all: "/libros",
    update: "/libros/:id",
    create: "/libros/crear",
  },
  Ejemplares: {
    all: "/ejemplares",
    update: "/ejemplares/:id",
    create: "/ejemplares/crear",
  },
  Biblioteca: {
    all: "/biblioteca",
  },
  AllPublications: {
    all: "/allPublications",
  },
  RESOURCEFOLDERS: {
    all: "/resource-folders",
    update: "/resource-folders/:id",
    create: "resource-folders/crear",
  },
  InvestigadoresInvitados: {
    all: "/investigadores-invitados",
    update: "/investigadores-invitados/:id",
    create: "/investigadores-invitados/crear",
  },
};
